"use strict";
(function($) {


	/* // при открытии модалки выделять первый инпут поля
	document.addEventListener('shown.bs.modal', function (el) {
		let modalFields = document.querySelector('.modal.show .form-control:enabled');
		if (modalFields) modalFields.focus()
	})
	*/


	//fakelink
	document.querySelectorAll('a[href="#"]').forEach(link =>
		link.addEventListener('click',(e)=>{e.preventDefault()})
	);


	window.toggleClass = function(el, $class = "active", self = this) {
		if(typeof el == 'string') el = document.querySelector(el)
		el.classList.toggle($class);
		if(typeof self != 'undefined') self.classList.toggle('_toggled');
	}



	/* loadTPL 22-06-02
		 *** есть параметр request: {title: 't1', data: 123}
		 *** Примеры использования:
		 *** loadTPL({url: './_view/_alert1.php', type:'notification'})
		 *** onclick="loadTPL({url: '<?=TPL;?>/_view/_modal1.php', type:'modal', request: {title:'name', num:123}})"
	*/
	window.loadTPL = function(args, event = false) {
		if(typeof window.event != 'undefined') window.event.preventDefault();
		// if (typeof args.url == 'undefined') {throw ("Нет url в параметрах вызова loadTPL");}

		new class {
			constructor() {
				let argsDefault = {
					common: {
						debug: false,
						placeTo: 'body', // селектор, куда кладём новый элемент
						type: 'html',
						notificationsWrapperEl: '_notifications__list'
					},

					type_modal: {
						doNotUnset: false, // убирать модалку из кода после закрытия
					},

				}

				this.args = args.type != '' ? // подгрузка дефолтных значений
					Object.assign(argsDefault.common, argsDefault['type_'+args.type], args)
					: Object.assign(argsDefault.common, args)

				// если область добавления - список _notifications__list
				if(this.args.placeTo == '_notifications__list') {
					if(document.getElementById(this.args.notificationsWrapperEl) == null) {
						// если нет #notifications - создаём
						document.querySelector('body').insertAdjacentHTML('beforeend',
							`<div id="${this.args.notificationsWrapperEl}" class="_notifications__list custom_scroll"></div>`
						);
					}
					this.args.placeTo = '#'+this.args.notificationsWrapperEl;
				}

				this.args.placeEl = document.querySelector(this.args.placeTo)
				this.args.debug ? console.log(this) : true;
				this.loadUrl()
			}


			// разное поведение loadTPL в зависимости от типа
			placeItem(html = null) {
				// null - чтобы сделать необязательным аргументом. Например, для type = default_alert
				switch (this.args.type) {
					case 'modal':  // настройка модалки
					this.addedHTMLel = placeHTML(html, this.args.placeEl);
					let new_modal = new bootstrap.Modal(this.addedHTMLel.html)
						this.addedHTMLel.html.addEventListener('hidden.bs.modal', () => { // удалять при закрытии
							if(args.doNotUnset != true) {
								new_modal.dispose()
								this.addedHTMLel.html.remove();
								if(typeof this.addedHTMLel.script != 'undefined') this.addedHTMLel.script.remove();
								new_modal = null;
							}
						});
						new_modal.show();
						break;


					/*
					case 'modal_default':  // настройка готовой модалки
						let modalHTML = `<div class="modal fade" tabindex="-1">
							<div class="modal-dialog">
								<div class="modal-content">
									<div class="modal-header">
										<h5 class="modal-title">${this.args.modal_title}</h5>
										<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
									</div>
									<div class="modal-body">${html}</div>
								</div>
							</div>
						</div>`;
						this.addedHTMLel = placeHTML(modalHTML, this.args.placeEl);
						let new_default_modal = new bootstrap.Modal(this.addedHTMLel.html)
						this.addedHTMLel.html.addEventListener('hidden.bs.modal', () => { // удалять при закрытии
							if(args.doNotUnset != true) {
								new_default_modal.dispose()
								this.addedHTMLel.html.remove();
								if(typeof this.addedHTMLel.script != 'undefined') this.addedHTMLel.script.remove();
								new_default_modal = null;
							}
						});
						new_default_modal.show();
						break;
					*/

					// case 'alert':
					// 	this.addedHTMLel = placeHTML(html, this.args.placeEl);
					// 		setTimeout(()=>{this.addedHTMLel.html.classList.add('show')}, 100);
					// 		this.checkAlertAutoclose();
					// 		break;


					case 'alert':
						if (this.args.data.can_close == true) {
							this.args.close_btn = '<button type="button" class="btn-close" data-bs-dismiss="alert"></button>'
							this.args.data.class += ' alert-dismissible'
						} else {
							this.args.close_btn = ''
						}

						this.args.html = `<div class="alert fade ${this.args.data.class}" role="alert">${this.args.data.content}${this.args.close_btn}</div>`;
						this.addedHTMLel = placeHTML(this.args.html, this.args.placeEl);
						setTimeout(()=>{this.addedHTMLel.html.classList.add('show')}, 100);
						if (typeof this.args.data.can_close != 'undefined') this.checkAlertAutoclose();
						break;


					default: placeHTML(html, this.args.placeEl); break;
				}
			}



			// TODO: Мож какой-либо спиннер, пока грузится?
			async loadUrl() {
				let url = this.args.url
				if(url) { // если есть урл
					if(typeof this.args.request != 'undefined')
						url += '?'+ new URLSearchParams(this.args.request).toString()
					fetch(url, {
						mode: 'cors', // no-cors, *cors, same-origin
						credentials: 'same-origin',
						cache: 'no-cache', // default, no-cache, reload, force-cache, only-if-cached
					})
					.then(response => {
						response.ok ? response.text().then(response_html => {
							this.placeItem(response_html)
					}) : false})
					.catch ((error) => {
						console.error('loadUrl error:','\n', error);
						reject(error);
					})
					.finally((final_data) => {})

				} else  { // если не нужен урл
					this.placeItem()
				}
			}


			checkAlertAutoclose(html) {
				if(!this.addedHTMLel.html.classList.contains('alert-dismissible')) return
				if (this.args.autoClose > 0) {
					console.log('autoclose exist')
					setTimeout(()=>{
						let alert = new bootstrap.Alert(this.addedHTMLel.html);
						alert.close();
					}, this.args.autoClose)
				}
			}
		}
	}




	/* FMS ver: 22-06-26
		*** [ Параметры полей в форме форм: ]
		***  data-fms="{params}" - пометка об обработке FMS
		***  data-fms_ignore="1" - игнорирование поля
		***  aria-label="Имя поля" - имя поля :)
		***
		[ Параметры FMS ]
		***  fms_subject: 'Тема письма',
		***  debug: 1,
		***  emailTo: %EMAIL_TO_GROUP_IN_CFG%,
		***  onSuccess: ()=>{loadTPL({type:'alert', placeTo: '_notifications__list', autoClose: 10000, data: {content: '<strong>Заяка отправлена.</strong><br> Мы скоро свяжемся с Вами!', class: 'alert-success', can_close: true}})}
	*/
	const FMS_DATASELECTOR = 'fms';
	class Fms {
		constructor(args) {
			window.event.preventDefault();

			let argsDefault = {
				el: window.event.target,
				debug: false,
				formData: new FormData(),
				onSuccess: null,
				onFail: null,
				cfg: {
					formSubmitBtnText: 'Отправляю...',
					spinner: '<div class="_form_spinner"><div class="spinner-border" role="status"></div></div>',
					submitBtn__text: window.event.target.querySelector('button[type=submit]').innerHTML
				}
			}
			this.args = Object.assign(argsDefault, args)

			this.args.debug ? console.log('fms_args:', '\n', this.args) : true;
			this.sendForm();
		}

		// отправка формы
		async sendForm() {
			this.formGetFields();
			this.formSetState('submit_before')

			if(this.args.debug) { // дебаг полей
				console.log('fms_send:');
				for (let formField of this.args.formData.entries()) {console.log(formField)}
			};

			fetch(window.location.href, {
				method: 'POST',
				mode: 'cors', // no-cors, *cors, same-origin
				credentials: 'same-origin',
				cache: 'no-cache', // default, no-cache, reload, force-cache, only-if-cached
				headers: {'X-Requested-With': 'XMLHttpRequest'},
				body: this.args.formData
			})
			.then(response => {
				response.ok ? response.json().then(response_json => {
					this.args.debug ? console.log('fms_success:', '\n', response_json) : true;
					this.formSetState('close_modal')
					this.args.onSuccess()
			}) : false})

			.catch ((error) => {
				this.args.debug ? console.error('Ошибка:', '\n', error) : false;
				this.args.onFail()
			})

			.finally(()=>{
				this.formSetState('submit_final')
			})

		}

		 // собираем поля
		formGetFields() {
			let formFields = this.args.el.querySelectorAll('*[name]');
			if(formFields.length) {
				formFields.forEach(formField => {
					if(formField.dataset.fms_ignore == 1) return // вместо continue
					if(formField.getAttribute('type') != 'file') {
						formField.value ?
							this.args.formData.append(this.formGetNiceName(formField), formField.value) : false
					} else {
						// загружаем добавленные файлы в formData
						formField.files.length ?
							this.args.formData.append(this.formGetNiceName(formField), formField.files[0]) : false
					}
				});
			}
			this.args.formData.append('fms_subject', this.args.fms_subject)
			// this.args.formData.fms_settings = this.args.fms_settings
			this.args.formData.append('fms_submit', true)
			this.args.emailTo ? this.args.formData.append('emailTo', this.args.emailTo) : false;
		}


		// визуальное изменение формы
		formSetState(state) {
			switch (state) {
				case 'submit_before':
					this.args.el.classList.add("sending")
					this.args.el.querySelector('button[type=submit]').innerHTML = this.args.cfg.formSubmitBtnText
					this.args.el.insertAdjacentHTML('beforeend', this.args.cfg.spinner)
					break

				case 'close_modal': // Закрытие открытых модалок
					let openModalEl = document.querySelector('.modal.show');
					if(openModalEl != null) {bootstrap.Modal.getOrCreateInstance(openModalEl).hide()}
					break;

				case 'submit_final':
					this.args.el.classList.remove("sending")
					this.args.el.querySelector('button[type=submit]').innerHTML = this.args.cfg.submitBtn__text
					this.args.el.querySelector('._form_spinner').remove()
					this.args.el.reset()
					break
			}
		}


		// красивые имена для полей
		formGetNiceName(field) {
			return field.getAttribute('aria-label') ?? field.getAttribute('name');
		}
	}
	window.FMS = (args)=>{let FMSform = new Fms(args)}







	// отложенная загрузка контента
	// USAGE: <div class="delayLoad" data-delay_load='<?=TPL;?>/_view/_modal-with_script2.php'></div>
	// class delayLoadClass {
	// new class {
	// 	constructor() {
	// 		this.args = {
	// 			isStart: false,
	// 			data_attr: 'delay_load',
	// 			delay_timeout: 2000,
	// 		}
	// 		// запуск отложенного события
	// 		window.addEventListener('touch', () => {this.checkStart()})
	// 		window.addEventListener('scroll', () => {this.checkStart()})
	// 		window.addEventListener('mousemove', () => {this.checkStart()})
	// 	}


	// 	checkStart() {
	// 		if (this.args.isStart === false) {
	// 			this.args.isStart = true;
	// 			this.start()
	// 			return true;
	// 		}
	// 		return false;
	// 	}


	// 	start() {
	// 		this.delayLoadElements = document.querySelectorAll('*[data-'+this.args.data_attr+']');
	// 		if(this.delayLoadElements.length) {
	// 			this.delayLoadElements.forEach(el => {
	// 				setTimeout(()=>{
	// 					this.loadAndPasteHTML(el);
	// 				}, this.args.delay_timeout);
	// 				})
	// 		}
	// 	}


	// 	loadAndPasteHTML(el) {
	// 		let url = el.dataset[this.args.data_attr];
	// 		fetch(url)
	// 		.then(response => {
	// 			response.ok ? response.text().then(response_html => {
	// 				placeHTML(response_html, el)
	// 				el.classList.add('loaded');
	// 		}) : false})
	// 		.catch ((error) => {
	// 			console.error('Ошибка загрузки:', '\n', error);
	// 			placeHTML('<div class="fw400 text-danger">Ошибка загрузки</div>', el)
	// 		})
	// 	}
	// }
	// const delayLoad = new delayLoadClass()



	// Аналог $.getScript() - отложенная загрузка скриптов (например, для модалок)
	// За основу бралось https://stackoverflow.com/questions/16839698/jquery-getscript-alternative-in-native-javascript
	// USAGE: loadResource('//cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js', () => {console.log('done')})
	function loadResource(url, callback) {
		let resource = {}
		resource.id = url.match(/(?:.+\/)(.+)/)[1] + '--' + url.match(/(?:[\w-]+\.)+[\w-]+/)[0]
		resource.ext = url.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[1]
		// console.log('loadResource', resource)
		let resource_dom = false
		switch (resource.ext) {
			case 'css':
					resource_dom = document.createElement('link')
					resource_dom.rel = "stylesheet"
					resource_dom.href = url
					break;
			case 'js':
					resource_dom = document.createElement('script')
					resource_dom.src = url;
					resource_dom.async = true
					break;
		}

		if(!document.getElementById(resource.id) && resource_dom) {
			resource_dom.id = resource.id;
			resource_dom.onload = callback;
			document.body.appendChild(resource_dom);
		} else {
			callback() // просто запуск callback-функции, раз всё уже есть в DOM
		}
	}



	function placeHTML(html, el = false) { // размещение html
		if(el === false) el = document.querySelector('body')

		// если есть скрипты - вырезаем их и запускаем отдельно
		const htmlData = {}
		htmlData.regexFindScript = html.match(/<script.*?>([\s\S]*?)<\/script>/)
		if(htmlData.regexFindScript) {
			htmlData.scriptText = htmlData.regexFindScript[1]
			htmlData.htmlWithoutScripts = html.replace(htmlData.regexFindScript[0], '')
			el.insertAdjacentHTML('beforeend', htmlData.htmlWithoutScripts) // вставляем HTML без скриптов
		}
		else {
			el.insertAdjacentHTML('beforeend', html) // вставляем изначальный HTML
		}

		const addedElements = {}
		addedElements.html = el.lastChild

		// вставляем script, если есть
		if(typeof htmlData.scriptText != 'undefined') {
			let script_dom = document.createElement('script')
			script_dom.async = true
			script_dom.textContent = htmlData.scriptText
			document.body.appendChild(script_dom);

			addedElements.script = script_dom
		}
		// console.log(addedElements)
		return addedElements;
	}




	// scroll affix + scroll to top
	window.addEventListener('scroll', ()=>{
		let scroll = window.scrollY;
		const scrollClass = 'scrolled'

		if (scroll >= 1) {
			document.body.classList.add(scrollClass)
		} else {
			document.body.classList.remove(scrollClass)
		}
	});
	window.dispatchEvent(new CustomEvent('scroll'))





	/* toogleItem
		*** Примеры использования:
	*/
	window.toggleItem = function(args = {}) {
		if(typeof window.event != 'undefined')
			window.event.preventDefault()


		new class {
			constructor() {
				let argsDefault = {
					el: 'body',
					class: 'show__toggled',
					self: false,
					backdrop: true
				}
				this.settings = {
					backdrop_id: 'backdrop',
					backdrop_html: '<div id="backdrop" class="offcanvas-backdrop fade"></div>'
				}
				this.args = Object.assign(argsDefault, args) // подгрузка дефолтных значений
				if(typeof this.args.el == 'string') this.args.el = document.querySelector(this.args.el)

				this.args.el.classList.contains(this.args.class)
					? this.hideItem()
					: this.showItem()
			}

			showItem() {
				document.querySelector(this.args.self).classList.add('toggled')
				this.args.el.classList.add(this.args.class)
				if(this.args.backdrop) this.backdrop_show()
			}

			hideItem() {
				document.querySelector(this.args.self).classList.remove('toggled')
				this.args.el.classList.remove(this.args.class)
				if(this.args.backdrop) this.backdrop_hide()
			}

			backdrop_show() {
				// document.body.innerHTML += this.settings.backdrop_html
				document.querySelector('body').insertAdjacentHTML('beforeend', this.settings.backdrop_html)
				this.backdrop = document.querySelector('#'+this.settings.backdrop_id)
				setTimeout(()=>this.backdrop.classList.add('show'), 100)
				this.backdrop.addEventListener('click',()=>this.hideItem())
			}

			backdrop_hide() {
				this.args.el.classList.remove(this.args.class)
				const all_backdrops = document.querySelectorAll('.offcanvas-backdrop')
				all_backdrops.forEach(function(el) {
					el.classList.remove('show')
					setTimeout(()=>el.remove(), 100)
				})
			}
		}
	}




	document.addEventListener("DOMContentLoaded", ()=>{
		const to_top_btn = document.querySelector("#to_top_btn")
		if(to_top_btn != null) {
			to_top_btn.addEventListener("click", function() {
				window.scroll({top: 0, behavior: "smooth"});
			})
		}




		let fancyboxes = document.querySelectorAll("[data-fancybox], .gallery-icon a")
		if(fancyboxes.length) {
			loadResource('//cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js', () => {
				loadResource('//cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css', () => {})
				// Fancybox.bind("[data-fancybox], .gallery-icon a", {})
			})
		}



		// _MANY_LETTERS:: Получаем все заголовки на странице
		// const headings = document.querySelector('#content').querySelectorAll('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6')
		// console.log(headings)
		// headings.forEach((heading) => { // Проходим по каждому заголовку
		// 	const text = heading.textContent.trim() // Получаем текст заголовка
		// 	if (text.length > 33)
		// 		heading.classList.add('_many_letters')
		// })
	})


// отложенная загрузка контента
window.AJAXload = function (el, url) {
	$(el).addClass('AJAXloading');
	$.get(url, function(loadedFile) {
		$(el).html(loadedFile);
		$(el).removeAttr('data-load');
		$(el).removeClass('AJAXloading');
	})
}
$('.load-wrap[data-load]').each(function(){
	if($(this).data('load') != '') { // если есть что грузить - грузим
		if($(this).data('load_delay') > 0) { // если есть отложенная загрузка
			let $this = $(this);
			setTimeout(function() {
				AJAXload($this, $this.data('load'));
			}, $this.data('load_delay'));
		} else { // иначе показываем сразу
				AJAXload($(this), $(this).data('load'));
		}
	} else { // иначе просто убираем спиннер
		$(this).addClass('ready');
	}
});



// POPOVER
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl)
})


document.querySelectorAll(".numToLocaleString").forEach(function(item) {
  item.innerHTML = parseInt(item.innerHTML).toLocaleString();
});








}) (jQuery);